var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48_571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6811 4.12365C15.5906 3.78326 15.4123 3.47259 15.1641 3.22275C14.9159 2.97291 14.6063 2.79265 14.2665 2.70001C13.0156 2.36365 8.01562 2.36365 8.01562 2.36365C8.01562 2.36365 3.01563 2.36365 1.76472 2.70001C1.42491 2.79265 1.1154 2.97291 0.86715 3.22275C0.618902 3.47259 0.440629 3.78326 0.35017 4.12365C0.015625 5.38001 0.015625 8.00001 0.015625 8.00001C0.015625 8.00001 0.015625 10.62 0.35017 11.8764C0.440629 12.2168 0.618902 12.5274 0.86715 12.7773C1.1154 13.0271 1.42491 13.2074 1.76472 13.3C3.01563 13.6364 8.01562 13.6364 8.01562 13.6364C8.01562 13.6364 13.0156 13.6364 14.2665 13.3C14.6063 13.2074 14.9159 13.0271 15.1641 12.7773C15.4123 12.5274 15.5906 12.2168 15.6811 11.8764C16.0156 10.62 16.0156 8.00001 16.0156 8.00001C16.0156 8.00001 16.0156 5.38001 15.6811 4.12365Z",
    fill: "#FF0302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.37939 10.3792V5.62097L10.5612 8.00006L6.37939 10.3792Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.35670abc67928393b9e6e4a7055a66ca.svg";
export { ForwardRef as ReactComponent };